import { render } from "./mentalHealthVideoManager.vue?vue&type=template&id=4c8a1762"
import script from "./mentalHealthVideoManager.vue?vue&type=script&lang=js"
export * from "./mentalHealthVideoManager.vue?vue&type=script&lang=js"

import "./mentalHealthVideoManager.vue?vue&type=style&index=0&id=4c8a1762&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__